import { TextStyle, ViewStyle } from "react-native"
import { color, dimensions } from "../../theme"

/**
 * The base switch view.
 */
export const VIEW: ViewStyle = {
  borderRadius: dimensions.buttonRadius,
  backgroundColor: color.secondary,
  flexDirection: "row",
  paddingHorizontal: 4,
  paddingVertical: 8,
}

/**
 * The base button, of the switch view, the styles are shared by both the button and the animated component
 * highlighting the selected button
 */
export const BASE_BUTTON: ViewStyle = {
  width: 150,
  height: 40,
  borderRadius: dimensions.buttonRadius,
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: color.transparent,
  marginHorizontal: 4,
}

/**
 * The animated component that highlights the selected option, it animates from one option to the other when the
 * component's value property is changed.
 */
export const BUTTON_ANIMATED: ViewStyle = {
  ...BASE_BUTTON,
  backgroundColor: color.background,
  position: "absolute",
  top: 8,
}

/**
 * Styles for the unselected option
 */
export const BUTTON_INACTIVE: ViewStyle = {
  ...BASE_BUTTON,
}

/**
 * Styles for the selected option
 */
export const BUTTON_ACTIVE: ViewStyle = {
  ...BASE_BUTTON,
}

export const TEXT: TextStyle = {
  textAlign: "center",
  color: "#03173A",
}

export const buttonPresets = {
  active: { ...BUTTON_ACTIVE } as ViewStyle,

  inactive: { ...BUTTON_INACTIVE } as ViewStyle,
}
